<template>
  <nav>
    <tabs :items="tabItems" />
  </nav>
</template>
<script>
import Vue from 'vue';
import Tabs from '@/components/phila-ui/Tabs';

export default {
  name: 'TabsNav',
  components: {
    Tabs,
  },
  data () {
    return {
      tabItems: [],
      filerScreenTabs: [ 
        'file-now',
        'filer-administration',
        'screens-and-menus',
        'reports',
        // 'pdf-test',
      ],
      subScreens: {
        'filer-administration': [
          'import-filers',
        ],
      },
    };
  },
  watch: {
    '$route' () {
      this.setTabs();
    },
  },
  created () {
    this.setTabs();
  },
  methods: {
    setTabs () {
      let tabs = [];
      this.filerScreenTabs.forEach(tab => {
        if (this.$store.getters['user/hasScreenAccess'](tab)) {
          let route = this.$router.resolve({ name: tab }).route;
          tabs.push({
            label: route.meta.label,
            link: route.name,
            isActive: this.isActive(route, tab),
            isRoute: true,
          });
        }
      });
      Vue.set(this, 'tabItems', tabs); 
    },
    isActive (route, tab) {
      if (this.$router.currentRoute.name === route.name || (this.subScreens[route.name] && this.subScreens[route.name].includes(this.$router.currentRoute.name))) {
        return true;
      }
      //highlight File Now tab for all filing child routes
      if (tab === 'file-now' && this.$route.matched[this.$route.matched.length - 2].name === 'filing') {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
  nav {
    position: relative;
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      li {
        width: auto;
        display: inline-block;
        background-color: #0f4d90;
        color: #fff;
        font-weight: 700;
        margin-right: 4px;
        text-align: center;
        &:last-child {
          margin-right: 0;
        }
        a {
          color: #fff;
          padding: 3px 15px;
          display: block;

          &.router-link-exact-active {
            background-color:  #444 !important;
            cursor: default;
            color: #fff;
          }
        }
        &.info-tab {
          background-color: #cfcfcf;
        }
      }
    }
  }
</style>
